module.exports = __webpack_public_path__ + "static/img/aniImgIos.717d8721.png";